import { Dom, animate } from '@brandocms/jupiter'

export default _app => ({
  rafScroll: true,
  el: 'header[data-nav]',
  default: {
    offsetSmall: () => {
      // if we have a hero, set to bottom of hero.
      const hero = Dom.find('[b-tpl="hero"]')
      if (hero) {
        // To get position from top of document, add window.scrollY
        return hero.getBoundingClientRect().bottom + window.scrollY
      }
      return 25
    },
    unPinOnResize: false,
    beforeEnter: _h => {},
    enter: _h => {},
    onPin: h => {
      // Transition booking bar when header pins
      const bookingBar = document.querySelector('.booking-bar')
      if (bookingBar) {
        bookingBar.classList.add('is-transitioning')
      }

      // Default header animation
      animate(h.el, { y: '0%' }, { duration: 0.35, ease: 'easeOut' }).then(() => {
        if (bookingBar) {
          bookingBar.classList.remove('is-transitioning')
        }
      })
    },
    onUnpin: h => {
      // Transition booking bar when header unpins
      const bookingBar = document.querySelector('.booking-bar')
      if (bookingBar) {
        bookingBar.classList.add('is-transitioning')
      }

      // Default header animation
      h._hiding = true
      animate(h.el, { y: '-100%' }, { duration: 0.25, ease: 'easeIn' }).then(() => {
        h._hiding = false
        if (bookingBar) {
          bookingBar.classList.remove('is-transitioning')
        }
      })
    },
    onMobileMenuOpen: h => {
      // Pin the header when menu opens so it stays visible
      h.pin()
    },
    onMobileMenuClose: _h => {
      // No special action needed when menu closes
    },
  },
})
